import { IIcd10CodesFilters } from '~/services/api/icd10Codes/types';

const getInitialFilters = (): IIcd10CodesFilters => ({
  search: '',
  userId: '',
});

export default getInitialFilters;
